import {
    onlineLeadStepsTitles,
    offlineLeadStepsTitles,
    progressClosingStepsTitles1,
    progressClosingStepsTitles2,
    progressSaleStepsTitles,
    partnershipStepsTitles,
    networkLeadStepsTitles,
    VRBankPartnerStepsTitles,
    prospectiveBuyerTitles,
    partnershipUpdateStepsTitles,
    imvPipelineTitles
} from "../../pages/pipelines/dnd-and-kanban-helpers";

export const networkPartnerPipeline = {
    _id: "contact-network-pipeline",
    type: "sub",
    parentPipeline: 1,
    pipeline: "network",
    pipelineTitle: "Netzwerk-Partner",
    steps: networkLeadStepsTitles,
    inner: 2,
    isDefault: true,
    info: "Hier finden Sie potenzielle Kontakte, welche Ihnen Leads bringen können, z.B. Handwerker.",
    route: "/setting/network",
    fullTitle: "Setting - Netzwerk-Partner",
    relatedTo: "contact"
};

export const partnershipPipeline = {
    _id: 5,
    type: "sub",
    parentPipeline: 1,
    pipeline: "partnership",
    pipelineTitle: "Tippgeber-Leads",
    steps: partnershipStepsTitles,
    inner: 2,
    isDefault: true,
    info: "Hier finden Sie Ihre Leads, welche Sie an Partner weiter vermitteln wollen.",
    nextPipeline: { _id: 6, pipelineTitle: "Closing" },
    route: "/partnership",
    fullTitle: "Tippgeber-Leads",
    relatedTo: "realEstate"
};

export const partnershipPipelineUpdate = {
    _id: 10,
    type: "sub",
    parentPipeline: 1,
    pipeline: "tipper-leads",
    pipelineTitle: "Tippgeber Funnel",
    steps: partnershipUpdateStepsTitles,
    inner: 2,
    isDefault: true,
    info: "Hier finden Sie Ihre Leads, welche Sie von Tippgeber erhalten haben.",
    nextPipeline: { _id: 6, pipelineTitle: "Closing" },
    route: "/tipper-leads",
    fullTitle: "Tippgeber Funnel",
    relatedTo: "realEstate"
};

export const imvPipeline = {
    _id: 11,
    type: "sub",
    parentPipeline: 1,
    pipeline: "imv",
    pipelineTitle: "IMV",
    steps: imvPipelineTitles,
    inner: 2,
    isDefault: true,
    nextPipeline: { _id: 6, pipelineTitle: "Closing" },
    route: "/imv",
    fullTitle: "IMV",
    info: "Hier finden Sie Leads, welche aus der IMV-Anbindung stammen.",
    relatedTo: "realEstate"
};

export const prospectiveBuyerPipeline = {
    _id: "contact-prospective-buyer-pipeline",
    type: "parent",
    pipeline: "prospective-buyer",
    pipelineTitle: "Wunschimmo",
    steps: prospectiveBuyerTitles,
    inner: 1,
    isDefault: true,
    route: "/prospective-buyer",
    fullTitle: "Wunschimmo-Leads",
    relatedTo: "contact"
};

export const defaultPipelines: any[] = [
    {
        _id: 1,
        type: "parent",
        hasSub: true,
        pipeline: "setting",
        pipelineTitle: "Setting",
        inner: 1,
        isDefault: true,
        relatedTo: "realEstate",
        subcategories: [
            {
                _id: 2,
                type: "sub",
                parentPipeline: 1,
                pipeline: "online",
                pipelineTitle: "Online Akquise",
                steps: onlineLeadStepsTitles,
                inner: 2,
                isDefault: true,
                info: "Hier finden Sie Leads, welche über Marketing-Kampagnen generiert wurden, z.B. über unsere Formulare.",
                nextPipeline: { _id: 6, pipelineTitle: "Closing" },
                route: "/setting/online",
                fullTitle: "Setting - Lead Bearbeitung",
                relatedTo: "realEstate"
            },
            {
                _id: 3,
                type: "sub",
                parentPipeline: 1,
                pipeline: "offline",
                pipelineTitle: "Offline Akquise",
                steps: offlineLeadStepsTitles,
                inner: 2,
                isDefault: true,
                info: "Hier finden Sie Leads, die Sie selber angelegt haben, z.B. über eigene Recherche oder Kaltakquise.",
                nextPipeline: { _id: 6, pipelineTitle: "Closing" },
                route: "/setting/offline",
                fullTitle: "Setting - Offline Akquise",
                relatedTo: "realEstate"
            },
            networkPartnerPipeline,
            partnershipPipeline,
            partnershipPipelineUpdate,
            imvPipeline
        ]
    },
    {
        _id: 6,
        type: "parent",
        pipeline: "closing",
        pipelineTitle: "Closing",
        steps: [...progressClosingStepsTitles1, ...progressClosingStepsTitles2],
        inner: 1,
        isDefault: true,
        nextPipeline: { _id: 7, pipelineTitle: "Verkauf" },
        route: "/closing",
        fullTitle: "Closing - Potenzial Pipeline",
        relatedTo: "realEstate"
    },
    {
        _id: 7,
        type: "parent",
        pipeline: "sale",
        pipelineTitle: "Verkauf",
        steps: progressSaleStepsTitles,
        inner: 1,
        isDefault: true,
        route: "/sale",
        fullTitle: "Immobilienverkauf",
        noAccessForNewAccounts: true,
        relatedTo: "realEstate"
    },
    {
        _id: 8,
        type: "parent",
        pipeline: "vr-bank-partners",
        pipelineTitle: "Lead Connect: VR",
        steps: VRBankPartnerStepsTitles,
        inner: 1,
        isDefault: true,
        route: "/vr-bank-partners",
        fullTitle: "Lead Connect: VR Banken",
        relatedTo: "realEstate"
    },
    prospectiveBuyerPipeline
    // {
    //     _id: 12,
    //     type: "parent",
    //     pipeline: "marketing-content",
    //     pipelineTitle: "Marketing Content",
    //     steps: marketingContentStepsTitles,
    //     inner: 1,
    //     isDefault: true,
    //     route: "/marketing-content",
    //     fullTitle: "Marketing Content",
    //     relatedTo: "realEstate"
    // }
];

export const defaultPipelinesInfo = defaultPipelines.reduce((acc, p: any) => {
    if (p?.subcategories?.length > 0) {
        p?.subcategories?.map(sub => (acc[sub.pipeline] = sub));
    } else {
        acc[p.pipeline] = p;
    }
    return acc;
}, {});
export const defaultPipelinesNames = Object.keys(defaultPipelinesInfo);

export const generateCustomPipelinesInfo = currentPipelines => {
    return currentPipelines?.reduce((acc, p) => {
        if (p?.subcategories?.length > 0) {
            p?.subcategories?.map(sub => (acc[sub.pipeline] = sub));
        } else {
            acc[p.pipeline] = p;
        }
        return acc;
    }, {});
};

// get pipelines where is at least 1 step
export const getCustomPipelinesArray = customPipelines => {
    const filteredPipelines = customPipelines
        ?.map(item =>
            item.hasSub && item.subcategories?.length > 0 ? { ...item, subcategories: item.subcategories.filter(sub => sub.steps?.length > 0) } : item
        )
        ?.filter(item => (item.subcategories?.length > 0 ? true : item.steps?.length > 0));

    return filteredPipelines;
};

export const generateCustomStepsInfo = currentPipeline => {
    let steps = currentPipeline?.steps?.map(st => ({ ...st, pipelineId: currentPipeline?._id }));

    if (currentPipeline?.nextPipeline) {
        const newNextStep = {
            title: `In ${currentPipeline.nextPipeline.pipelineTitle} verschieben`,
            progress: `NEXT_${currentPipeline.nextPipeline.pipeline}_PIPELINE`,
            progressName: currentPipeline.nextPipeline.pipeline,
            pipelineId: currentPipeline.nextPipeline?._id
        };
        steps = [...steps, newNextStep];
    } else if (currentPipeline?.defaultNextPipeline) {
        const newNextStep = {
            title: `In ${currentPipeline.defaultNextPipeline.pipelineTitle} verschieben`,
            progress: `NEXT_${currentPipeline.defaultNextPipeline.pipeline?.toUpperCase()}_PIPELINE`,
            progressName: currentPipeline.defaultNextPipeline.pipeline,
            useDefaultPipeline: true
        };
        steps = [...steps, newNextStep];
    }

    return steps;
};

export const generateCustomContactStepsInfo = currentPipeline => {
    let steps = currentPipeline?.steps;

    if (currentPipeline?.nextPipeline) {
        const newNextStep = {
            title: `In ${currentPipeline.nextPipeline.pipelineTitle} verschieben`,
            progress: `NEXT_${currentPipeline.nextPipeline.pipeline}_PIPELINE`,
            progressName: currentPipeline.nextPipeline.pipeline
        };
        steps = [...steps, newNextStep];
    }

    return steps;
};

export const getCurrentStepTitle = (customPipelines, progressStep) => {
    const getCurrentCategory = () => {
        if (progressStep?.category === "partnership") {
            return partnershipPipeline;
        } else if (progressStep?.category === "tipper-leads") {
            return partnershipPipelineUpdate;
        } else if (progressStep?.category === "imv") {
            return imvPipeline;
        } else return defaultPipelines.find(p => p.pipeline === progressStep?.category) ?? customPipelines.find(p => p.pipeline === progressStep?.category);
    };
    const category = getCurrentCategory();

    let title;
    if (category?.hasSub) {
        const type = category?.subcategories && [...category?.subcategories]?.find(sub => sub.pipeline === progressStep?.type);
        const step = type?.steps && [...type?.steps]?.find(s => s.progress === progressStep?.step);
        title = `${type?.pipelineTitle}, ${step?.title}`;
    } else {
        const step = category?.steps && [...category?.steps]?.find(s => s.progress === progressStep?.step);
        title = `${category?.pipelineTitle}, ${step?.title}`;
    }
    return title;
};

export const getSubscriptionAmount = currentPipelines => {
    const amount = currentPipelines?.reduce((acc, item) => {
        if (item.hasSub) acc += item.subcategories?.length;
        else acc += 1;
        return acc;
    }, 0);
    return amount;
};

// it uses if we need full objects with accessed pipelines
export const getFullAccessedPipelines = (accessed, customPipelines) => {
    const customPipelinesArray = getCustomPipelinesArray(customPipelines);
    return customPipelinesArray?.reduce((acc, p) => {
        if (p.subcategories?.length > 0) acc = [...acc, { ...p, subcategories: p.subcategories.filter(sub => accessed.includes(sub._id)) }];
        else if (accessed.includes(p._id)) acc = [...acc, p];

        return acc.filter(p => !(p.hasSub && p.subcategories?.length === 0));
    }, []);
};

// get visibility of pipeline
export const generateVisibleDefaultPipeline = ({ info, pipelineCenter, relatedTo = undefined }) => {
    const getCurrentVisible = value => (value?.visibleInNav !== undefined ? value?.visibleInNav : true);

    if (info.subcategories?.length > 0) {
        let subs = info.subcategories;
        if (relatedTo) {
            subs = info.subcategories?.filter(p => p.relatedTo === relatedTo);
        }
        const isShownSubcategories = subs?.filter(p => getCurrentVisible(pipelineCenter?.[p.pipeline]));

        return isShownSubcategories?.length > 0 ? { ...info, subcategories: isShownSubcategories } : undefined;
    } else {
        return getCurrentVisible(pipelineCenter?.[info.pipeline]) ? info : undefined;
    }
};
export const generateVisibleCustomPipeline = ({ info, relatedTo = undefined }) => {
    if (info.subcategories?.length > 0) {
        let subs = info.subcategories;
        if (relatedTo) {
            subs = info.subcategories?.filter(p => p.relatedTo === relatedTo);
        }
        const isShownSubcategories = subs?.filter(el => el.isShown || el.isShown === undefined);

        return isShownSubcategories?.length > 0 ? { ...info, subcategories: isShownSubcategories } : undefined;
    } else {
        const visible = info.isShown !== undefined ? info.isShown : true;
        return visible ? info : undefined;
    }
};
